module.exports = __webpack_public_path__ + "img/u150.0d7e6143.jpg";